import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  despachos: [],
  totalCount: 0,
  loading: false,
}

export const Slice = createSlice({
  name: 'despachos',
  initialState,
  reducers: {
    setDespachos: (state, action) => {
      state.despachos = action.payload
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
  },
})

export const { setDespachos, setTotalCount, setLoading } = Slice.actions
export default Slice.reducer
